module.exports = __webpack_public_path__ + "img/i-games-categories-admin.6e88dd9c.svg";